import { useState } from "react";
import Check from "@mui/icons-material/Check";
import LanguageIcon from "@mui/icons-material/Language";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Button,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import { useLanguage } from "hooks";

export const LanguageSwitcher = ({ isMobile }: { isMobile: boolean }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { languages, selectedLanguage, onLanguageChange } = useLanguage();
  const open = Boolean(anchorEl);

  return (
    <>
      <Button
        variant="text"
        sx={{
          color: (theme) => theme.palette.blue.main,
          fontWeight: "normal",
          flexDirection: "row",
          gap: 1,
          ":hover": { textDecoration: "underline" },
        }}
        id="language-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <LanguageIcon />
        <span>
          {isMobile ? selectedLanguage?.shortLabel : selectedLanguage?.label}
        </span>
        <ExpandMoreIcon />
      </Button>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => {
          setAnchorEl(null);
        }}
        slotProps={{ list: { "aria-labelledby": "language-button" } }}
      >
        {languages.map(({ label, code, selected }) => (
          <MenuItem
            key={code}
            selected={selected}
            onClick={() => {
              onLanguageChange(code);
              setAnchorEl(null);
            }}
          >
            {selected && (
              <ListItemIcon>
                <Check />
              </ListItemIcon>
            )}
            <ListItemText inset={!selected}>{label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
